import { ILookupModel } from 'services';

/**
 * SetupFilteredTagsList
 *
 * @description Helper method to setup the list of tags which will render above the search results
 * @param {string}              fieldName      Parent field name which contains the list of items
 * @param {Array<string>}       selectedValues List of selected values on the form
 * @param {Array<ILookupModel>} filters        List of the categories which will be mapped to the tags
 * @returns {Array<ILookupModel>} List of tags to render
 */
export const setupFilteredTagsList = (fieldName: string, selectedValues: Array<string>, filters: Array<ILookupModel>): Array<ILookupModel & { fieldName: string; }> => {
  // Categories are loaded from the API on load so they will never be null here we assume but this is just an extra type-safety check to avoid unhandled exception.
  if (!filters || filters.length <= 0) {
    return [];
  }

  const selectedFilters = selectedValues.map((type: string) => ({
    fieldName: fieldName,
    ...filters.find(option => option.value === type)
  }));

  // Because the find inside the abobe map can return null or undefined we just want to filter them out
  return selectedFilters.filter(selectedOption => selectedOption) as Array<ILookupModel & { fieldName: string; }>;
};